import { QTableProps } from "quasar";
import { Symbols } from "@/shared/data-display-config/composable/data-display.helper";

export const QIT_PREVIEW_IMAGE_COLUMN = "qit-preview-image";
export const QIT_PREVIEW_IMAGE_ROW_FIELD = "qitPreviewImageUrl";

export type QTableRowCellValue = {
    formattedValue: string;
    symbols?: Symbols;
    isLink?: boolean;
};

export type QTableRowType = {
    id: string;
    previewImageUrl?: string; // url to preview image, when provided by backend
    /** Title can be a plain string or a structured cell value when populated via DataDisplayConfig */
    title?: string | QTableRowCellValue;
} & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- rows intentionally carry heterogeneous backend payloads accessed dynamically across many features
    [key: string]: string | QTableRowCellValue | any; // TODO: could maybe narrowed down to specific types like string | number | ComponentX | ...
};

export interface QDataSource {
    columns: QTableProps["columns"];
    mobileColumns?: QTableProps["columns"];
    rows?: QTableRowType[];
    visibleColumns?: string[];
}

/**
 * Resolves a QTableRowType cell value to a plain string.
 * Handles both raw string values and structured QTableRowCellValue objects.
 */
export const resolveCellText = (value: string | QTableRowCellValue | undefined): string | undefined => {
    if (value === undefined) return undefined;
    if (typeof value === "string") return value;

    return value.formattedValue;
};
